import React from 'react';
import CapitalContents from '@di-shared/features/capital/CapitalContents';

export interface FinanceBetaContentsProps {
  vin: string;
}

function FinanceBetaContents({vin}: FinanceBetaContentsProps): JSX.Element {
  return (
    <CapitalContents
      vin={vin}
      isProduction={false}
    />
  );
}

export default FinanceBetaContents;
